// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOauthAppleLinkBody = {
  idToken: string;
};

export type typeOauthAppleLinkOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { apple: { isLinked: boolean; linkedAt: string } };
};

export type typeOauthAppleLinkOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthAppleLinkOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthAppleLinkOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOauthAppleLinkBody = {
  type: "object",
  properties: { idToken: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["idToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOauthAppleLink(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOauthAppleLinkBody);
  }

  return async function postOauthAppleLink(
    payload: typeOauthAppleLinkBody,
  ): Promise<typeOauthAppleLinkOutput200 | typeOauthAppleLinkOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOauthAppleLink" failed before calling the network. #41027d73e496`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#41027d73e496" },
        },
        data: null,
      } as typeOauthAppleLinkOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/oauth/apple-link`,
      httpMethod: "POST",
      options,
    })) as typeOauthAppleLinkOutput200 | typeOauthAppleLinkOutput400;
  };
}
